export default __webpack_public_path__ + "static/media/gallery_04.37891c29.jpg";